export default __webpack_public_path__ + "static/media/angolo-v2-light.dcb7b48c.svg";